import api from "../../../services/axiosConfig";

export const fetchUsers = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyechart/users-list", {
      data: {},
    });
    return response.data.data.users;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const addUser = async (userData) => {
  try {
    const formData = new FormData();
    formData.append("firstName", userData.firstName);
    formData.append("lastName", userData.lastName);
    formData.append("username", userData.username);
    formData.append("email", userData.email);
    formData.append("password", userData.password);
    formData.append("active", userData.active.toString());

    userData.roleIds.forEach((roleId) => {
      formData.append("roleIds", roleId);
    });

    const response = await api.post(
      "/instances/skeye/skeyechart/new-user",
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

export const updateUser = async (userData) => {
  try {
    const formData = new FormData();
    formData.append("firstName", userData.firstName);
    formData.append("lastName", userData.lastName);
    formData.append("username", userData.username);
    formData.append("email", userData.email);

    // Only append active if it's true
    if (userData.active === true) {
      formData.append("active", "true");
    }

    userData.roleIds.forEach((roleId) => {
      formData.append("roleIds", roleId);
    });

    const response = await api.put(
      `/instances/skeye/skeyechart/user/${userData.userId}`,
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await api.delete(
      `/instances/skeye/skeyechart/user/${userId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
